import { TransformerPhase } from "../../constants/phase";
import { TransformerTypeReference } from "../../model/reference/referenceTypes";
import { TransformerMounting } from "../../model/viewModel/transformerProperties";

// groupBy helper
function groupBy<T, K>(items: T[], key: (item: T) => K): Map<K, T[]> {
  const m = new Map<K, T[]>();
  for (let i = 0; i < items.length; i++) {
    const it = items[i];
    const k = key(it);
    const arr = m.get(k) ?? [];
    arr.push(it);
    m.set(k, arr);
  }
  return m;
}

export function isTypeForMountingAndPhase(
  t: TransformerTypeReference,
  mounting: TransformerMounting,
  numberOfPhases: TransformerPhase,
): boolean {
  const key = `${numberOfPhases.toLowerCase()}phase` as "singlephase" | "splitphase" | "threephase";

  // normalize mounting (transformer data uses lowercase keys)
  const mountKey = mounting.toLowerCase() as "gmt" | "pmt";

  return !!t[key]?.[mountKey];
}

/** Build a Map<primaryVoltagekV, TransformerTypeReference[]> for a given mounting & phase. */
export function byPrimaryVoltage(
  types: TransformerTypeReference[],
  mounting: TransformerMounting,
  numberOfPhases: TransformerPhase,
): Map<number, TransformerTypeReference[]> {
  const filtered = types.filter((t) => isTypeForMountingAndPhase(t, mounting, numberOfPhases));
  return groupBy(filtered, (t) => Number(t.primaryVoltagekV));
}

/** Sorted (desc) list of Primary Voltage keys (kV) from a byPrimaryVoltage map. */
export function primaryVoltageKeysDesc(map: Map<number, TransformerTypeReference[]>): number[] {
  return Array.from(map.keys()).sort((a, b) => b - a);
}

export type { TransformerTypeReference, TransformerMounting, TransformerPhase };
